import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import OrganizationList from "./OrganizationList";
import OrganizationAddress from "./OrganizationAddress";
import OrganizationContact from "./OrganizationContact";

import organizationLogo from './assets/school-logo.png';

const Dashboard = () => {
  const location = useLocation();
  const navigate = useNavigate();

  // ✅ Get tab from URL safely
  const getTabFromURL = () => {
    const params = new URLSearchParams(location.search);
    return params.get("tab") || "Details";
  };

  const [activeTab, setActiveTab] = useState(getTabFromURL);

  // ✅ Ensure state updates when URL changes
  useEffect(() => {
    const newTab = getTabFromURL();
    if (newTab !== activeTab) {
      setActiveTab(newTab);
    }
  }, [location.search]);

  // ✅ Ensure URL updates only when tab changes
  useEffect(() => {
    if (activeTab && location.search !== `?tab=${activeTab}`) {
      navigate(`?tab=${activeTab}`, { replace: true });
    }
  }, [activeTab, navigate, location.search]);

  const renderComponent = () => {
    switch (activeTab) {
      case "Details":
        return <OrganizationList />;
      case "Address":
        return <OrganizationAddress />;
      case "Contacts":
        return <OrganizationContact />;
      default:
        return <div>Error: Tab not found</div>;
    }
  };

  return (
    <div style={{ display: "flex", width: "100vw", height: "100vh" }}>
      {/* Sidebar */}
      <div style={{ width: "20%", backgroundColor: "#C5E2FC", minHeight: "100vh", padding: "20px" }}>
        <img src={organizationLogo} alt='Dashboard Logo' width='100' height='100' />
        <div style={{ display: "flex", flexDirection: "column", marginTop: "20px", gap: "10px" }}>
          {["Details", "Address", "Contacts"].map((tab) => (
            <p
              key={tab}
              style={{
                fontSize: '14px',
                fontWeight: '600',
                lineHeight: '20px',
                color: activeTab === tab ? '#ffffff' : '#000000',
                backgroundColor: activeTab === tab ? "#445164" : "transparent",
                padding: "8px 12px",
                borderRadius: "5px",
                cursor: "pointer"
              }}
              onClick={() => setActiveTab(tab)}
            >
              {tab}
            </p>
          ))}
        </div>
      </div>

      {/* Main Content */}
      <div className="main-content" style={{ width: "78%", backgroundColor: '#ffffff', padding: "20px" }}>
        {renderComponent()}
      </div>
    </div>
  );
};

export default Dashboard;
